<nz-tabset
  nzType="card"
  class="bordered-tabs two-option"
  [nzTabBarExtraContent]="extraTemplate"
  [(nzSelectedIndex)]="selectedTabIndex">
  <nz-tab nzTitle="Cases" class="cases-tab"
    ><app-cases *ngIf="selectedTabIndex === 0" [tabIndex]="selectedTabIndex"
  /></nz-tab>
  <nz-tab nzTitle="Students" class="students-tab"
    ><app-students *ngIf="selectedTabIndex === 1" [tabIndex]="selectedTabIndex"
  /></nz-tab>
</nz-tabset>

<ng-template #extraTemplate>
  <div class="cta-wrapper" *ngIf="selectedTabIndex === 1">
    <button
      type="button"
      nz-button
      [nzType]="'primary'"
      class="btn"
      (click)="openStudentDrawer()">
      Import Student
    </button>
  </div>
</ng-template>
<ng-template #footerTpl> </ng-template>
